import React, {
  useEffect,
  useState,
} from "react";

import {
  Link,
  graphql,
  useStaticQuery,
} from "gatsby";

import {
  GatsbyImage,
  getImage,
} from "gatsby-plugin-image";

import "./Footer.scss";

import {
  getInitialLocale,
} from "../../utils/i18n";

import {
  LegalLinks
} from "../privacy";




export default function Footer() {


  const [locale, setLocale] =
    useState("en");



  useEffect(() => {

    setLocale(
      getInitialLocale()
    );

  }, []);


  const contactPath =
  locale === "en"
    ? "/en/contact"
    : "/it/contatti";
  



  const data = useStaticQuery(graphql`

    query FooterLogoQuery {

      logo:

      file(
        relativePath: {
          eq: "logo_sorrentoadvice_icon.png"
        }
      ) {

        childImageSharp {

          gatsbyImageData(

            width: 80

            placeholder: BLURRED

            quality: 85

          )

        }

      }

    }

  `);




  const logoImage =
    getImage(
      data.logo.childImageSharp.gatsbyImageData
    );






  return (


    <footer className="footer">


      <div className="container footerContent">


        <Link

          to="/"

          className="footerLogo"

        >


          {
            logoImage && (


              <GatsbyImage

                image={logoImage}

                alt="SorrentoAdvice"

                className="footerLogoImage"

              />


            )

          }


        </Link>





        <div className="footerCopyright">


          <span>

            © {new Date().getFullYear()} SorrentoAdvice. All rights reserved. -

          </span>


          <Link to={contactPath}>
            {locale === "it" ? "Contatti" : "Contact"}
          </Link>


          <LegalLinks

            privacyPolicyUrl={
              `/${locale}/privacy-policy`
            }

            cookiePolicyUrl={
              `/${locale}/cookie-policy`
            }

          />





        </div>



      </div>



    </footer>


  );

}